module.exports = __webpack_public_path__ + "static/media/aze.01b89fa1.svg";